import HsyIframe from '@/components/HsyIframe'

export default function RedNoticePage() {
  return <HsyIframe pageName={'红字信息表'} />
}
import HsyIframe from '@/components/HsyIframe'

export default function RedNoticePage() {
  return <HsyIframe pageName={'红字信息表'} />
}
